'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024111 from "./presto.-Presto-Router$$anon$111.js";
import * as $j_presto$002e$002dUnknown$002dPage$0024 from "./presto.-Unknown-Page$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$110() {
  this.ber = null;
  this.bej = null;
  this.bek = false;
  this.bes = null;
  this.bet = false;
  this.bew = null;
  this.bep = null;
  this.beq = false;
  this.bel = null;
  this.bem = false;
  this.ben = null;
  this.beo = false;
  this.beu = false;
  this.bev = false;
  this.ber = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bew = "UnknownPage";
}
export { $c_Lpresto_PrestoRouter$$anon$110 as $c_Lpresto_PrestoRouter$$anon$110 };
$p = $c_Lpresto_PrestoRouter$$anon$110.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$110;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$110() {
}
export { $h_Lpresto_PrestoRouter$$anon$110 as $h_Lpresto_PrestoRouter$$anon$110 };
$h_Lpresto_PrestoRouter$$anon$110.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.ber;
});
$p.L = (function() {
  if ((!this.bek)) {
    this.bej = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bek = true;
  }
  return this.bej;
});
$p.O = (function() {
  if ((!this.bet)) {
    this.bes = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bet = true;
  }
  return this.bes;
});
$p.E = (function() {
  return this.bew;
});
$p.t = (function() {
  if ((!this.beq)) {
    this.bep = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("str", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.beq = true;
  }
  return this.bep;
});
$p.M = (function() {
  if ((!this.bem)) {
    this.bel = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bem = true;
  }
  return this.bel;
});
$p.Q = (function() {
  if ((!this.beo)) {
    this.ben = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024111.$c_Lpresto_PrestoRouter$$anon$111();
    this.beo = true;
  }
  return this.ben;
});
$p.w = (function() {
  if ((!this.bev)) {
    this.beu = false;
    this.bev = true;
  }
  return this.beu;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee658) => ((p) => \u03b4scrutinee658.cGj(p)))($j_presto$002e$002dUnknown$002dPage$0024.$m_Lpresto_UnknownPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$110 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$110, "presto.PrestoRouter$$anon$110", ({
  Nz: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$110 as $d_Lpresto_PrestoRouter$$anon$110 };
//# sourceMappingURL=presto.-Presto-Router$$anon$110.js.map
